import { useCallback } from "react";

import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { PageEnum, useSpaceContext } from "@tudigo-monorepo/tudigo-session";
import {
  ComparatorSelectableItem,
  useComparator,
} from "@tudigo-monorepo/web-tudigo-comparator";
import {
  UI_PROJECTS_COMPARATOR_SELECTION_PROJECT_ADDED,
  UI_PROJECTS_COMPARATOR_SELECTION_PROJECT_DELETED,
} from "@tudigo-monorepo/web-tudigo-tracking";

import { ProjectCardComposed } from "../../../shared-external/components/project-card/composed/project-card.composed";
import { useProjectsComparatorCustomerTracking } from "../hooks/use-projects-comparator-customer-tracking";

export const SelectableProjectsCardGrid = (props: { projects: Project[] }) => {
  const { currentPagePaths } = useSpaceContext();
  const { urlState } = useComparator();
  const comparatorMode = urlState.mode;
  const { customerTrackComparator } = useProjectsComparatorCustomerTracking();

  const getProjectLinkPath = useCallback(
    (project: Project) => {
      if (comparatorMode === null) {
        return currentPagePaths[PageEnum.PROJECT].replace(
          ":projectId",
          project.content?.slug ?? project.id,
        );
      }
    },
    [comparatorMode, currentPagePaths],
  );

  return (
    <section className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
      {props.projects.map((project: Project) => (
        <ComparatorSelectableItem
          key={project.id}
          item={project}
          onUpdate={(selected) => {
            const eventName = selected
              ? UI_PROJECTS_COMPARATOR_SELECTION_PROJECT_ADDED
              : UI_PROJECTS_COMPARATOR_SELECTION_PROJECT_DELETED;

            customerTrackComparator(eventName, {
              project_id: project.id,
              project_name: project.content?.name,
            });
          }}
        >
          <ProjectCardComposed
            project={project}
            className="min-w-[300px] md:min-w-[354px]"
            to={getProjectLinkPath(project)}
          />
        </ComparatorSelectableItem>
      ))}
    </section>
  );
};
